import React from "react";
import { PolarArea } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import "./Polar_Area_Chart.css";

// Register the required chart components
ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

function Polar_Area_Chart({ response }) {
  // Chart data
  const data = {
    labels: response?.labels,
    datasets: [
      {
        label: "Users",
        data: response?.data,
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],

        borderWidth: 1,
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        enabled: true,
      },
    },

    scales: {
      r: {
        grid: {
          color: "#ccc", // Set orbit (grid line) color to #ccc
        },
        ticks: {
          display: true, // Show tick labels if needed
        },
      },
    },
  };

  return (
    <section className="main_Chart">
      <div className="heading-holder">
        <h4>Total Users & Agents</h4>
      </div>
      <div className="chart-holder">
        <PolarArea data={data} options={options} />
      </div>
    </section>
  );
}

export default Polar_Area_Chart;
